import { TransferCalcRound, TransferStatus } from "./enums";

export const TransferDepositStatusSearchOptions = Object.freeze([
  { label: "已作廢", value: TransferStatus.invalid },
  { label: "已建立", value: TransferStatus.created },
  {
    label: "已到帳",
    value: TransferStatus.arrived_with_right_amount,
  },
  {
    label: "待檢核",
    value: TransferStatus.arrived_with_wrong_amount,
  },
  { label: "已通過", value: TransferStatus.checked_and_allowed },
  { label: "已拒絕", value: TransferStatus.checked_and_refused },
  { label: "已逾時", value: TransferStatus.expired },
  {
    label: "待檢核（不提示）",
    value: TransferStatus.arrived_with_wrong_amount_and_muted,
  },
]);

export const TransferWithdrawStatusSearchOptions = Object.freeze([
  { label: "已作廢", value: TransferStatus.invalid },
  { label: "待審核", value: TransferStatus.created },
  { label: "已通過", value: TransferStatus.allowed },
  { label: "已拒絕", value: TransferStatus.refused },
  { label: "轉帳中", value: TransferStatus.transed },
  { label: "已到帳", value: TransferStatus.arrived },
  { label: "已逾時", value: TransferStatus.expired },
  { label: "交易異常", value: TransferStatus.errored_with_transaction_failure },
]);

export const TransferDepositStatusText = Object.freeze({
  [TransferStatus.invalid]: "已作廢",
  [TransferStatus.created]: "已建立",
  [TransferStatus.allowed]: "已通過",
  [TransferStatus.refused]: "已拒絕",
  [TransferStatus.transed]: "轉帳中",
  [TransferStatus.arrived]: "已到帳",
  [TransferStatus.arrived_with_right_amount]: "已到帳",
  [TransferStatus.arrived_with_wrong_amount]: "待檢核",
  [TransferStatus.checked_and_allowed]: "已通過",
  [TransferStatus.checked_and_refused]: "已拒絕",
  [TransferStatus.expired]: "已逾時",
  [TransferStatus.arrived_with_wrong_amount_and_muted]: "待檢核（不提示）",
  // 打款
  [TransferStatus.dist_insufficient]: "打款錢包餘額不足",
  [TransferStatus.dist_daily_excessive]: "打款錢包已達上限",
  [TransferStatus.dist_weekly_excessive]: "打款錢包已達上限",
  [TransferStatus.dist_monthly_excessive]: "打款錢包已達上限",
  // 收款
  [TransferStatus.recv_insufficient]: "收款錢包餘額不足",
  [TransferStatus.recv_daily_excessive]: "收款錢包已達上限",
  [TransferStatus.recv_weekly_excessive]: "收款錢包已達上限",
  [TransferStatus.recv_monthly_excessive]: "收款錢包已達上限",
  // 發生錯誤
  [TransferStatus.errored_with_unknown_reason]: "不明錯誤",
  [TransferStatus.errored_with_transaction_failure]: "交易異常",
});

export const TransferWithdrawStatusText = Object.freeze({
  [TransferStatus.invalid]: "已作廢",
  [TransferStatus.created]: "待審核",
  [TransferStatus.allowed]: "已通過",
  [TransferStatus.refused]: "已拒絕",
  [TransferStatus.transed]: "轉帳中",
  [TransferStatus.arrived]: "已到帳",
  [TransferStatus.arrived_with_right_amount]: "已到帳",
  [TransferStatus.arrived_with_wrong_amount]: "待檢核",
  [TransferStatus.checked_and_allowed]: "已通過",
  [TransferStatus.checked_and_refused]: "已拒絕",
  [TransferStatus.expired]: "已逾時",
  [TransferStatus.arrived_with_wrong_amount_and_muted]: "待檢核（不提示）",
  // 打款
  [TransferStatus.dist_insufficient]: "打款錢包餘額不足",
  [TransferStatus.dist_daily_excessive]: "打款錢包已達上限",
  [TransferStatus.dist_weekly_excessive]: "打款錢包已達上限",
  [TransferStatus.dist_monthly_excessive]: "打款錢包已達上限",
  // 收款
  [TransferStatus.recv_insufficient]: "收款錢包餘額不足",
  [TransferStatus.recv_daily_excessive]: "收款錢包已達上限",
  [TransferStatus.recv_weekly_excessive]: "收款錢包已達上限",
  [TransferStatus.recv_monthly_excessive]: "收款錢包已達上限",
  // 發生錯誤
  [TransferStatus.errored_with_unknown_reason]: "不明錯誤",
  [TransferStatus.errored_with_transaction_failure]: "交易異常",
});

export const TransferSelfDepositStatusText = Object.freeze({
  [TransferStatus.invalid]: "未到帳",
  [TransferStatus.created]: "申請中",
  [TransferStatus.allowed]: "已通過",
  [TransferStatus.refused]: "已拒絕",
  [TransferStatus.transed]: "轉帳中",
  [TransferStatus.arrived]: "已到帳",
  [TransferStatus.arrived_with_right_amount]: "已到帳",
  [TransferStatus.arrived_with_wrong_amount]: "待檢核",
  [TransferStatus.checked_and_allowed]: "已通過",
  [TransferStatus.checked_and_refused]: "已拒絕",
  [TransferStatus.expired]: "已逾時",
  [TransferStatus.arrived_with_wrong_amount_and_muted]: "待檢核（不提示）",
  // 打款
  [TransferStatus.dist_insufficient]: "打款錢包餘額不足",
  [TransferStatus.dist_daily_excessive]: "打款錢包已達上限",
  [TransferStatus.dist_weekly_excessive]: "打款錢包已達上限",
  [TransferStatus.dist_monthly_excessive]: "打款錢包已達上限",
  // 收款
  [TransferStatus.recv_insufficient]: "收款錢包餘額不足",
  [TransferStatus.recv_daily_excessive]: "收款錢包已達上限",
  [TransferStatus.recv_weekly_excessive]: "收款錢包已達上限",
  [TransferStatus.recv_monthly_excessive]: "收款錢包已達上限",
  // 發生錯誤
  [TransferStatus.errored_with_unknown_reason]: "不明錯誤",
  [TransferStatus.errored_with_transaction_failure]: "交易異常",
});

export const TransferSelfWithdrawStatusText = Object.freeze({
  [TransferStatus.invalid]: "已作廢",
  [TransferStatus.created]: "申請中",
  [TransferStatus.allowed]: "已通過",
  [TransferStatus.refused]: "已拒絕",
  [TransferStatus.transed]: "轉帳中",
  [TransferStatus.arrived]: "已到帳",
  [TransferStatus.arrived_with_right_amount]: "已到帳",
  [TransferStatus.arrived_with_wrong_amount]: "待檢核",
  [TransferStatus.checked_and_allowed]: "已通過",
  [TransferStatus.checked_and_refused]: "已拒絕",
  [TransferStatus.expired]: "已逾時",
  [TransferStatus.arrived_with_wrong_amount_and_muted]: "待檢核（不提示）",
  // 打款
  [TransferStatus.dist_insufficient]: "打款錢包餘額不足",
  [TransferStatus.dist_daily_excessive]: "打款錢包已達上限",
  [TransferStatus.dist_weekly_excessive]: "打款錢包已達上限",
  [TransferStatus.dist_monthly_excessive]: "打款錢包已達上限",
  // 收款
  [TransferStatus.recv_insufficient]: "收款錢包餘額不足",
  [TransferStatus.recv_daily_excessive]: "收款錢包已達上限",
  [TransferStatus.recv_weekly_excessive]: "收款錢包已達上限",
  [TransferStatus.recv_monthly_excessive]: "收款錢包已達上限",
  // 發生錯誤
  [TransferStatus.errored_with_unknown_reason]: "不明錯誤",
  [TransferStatus.errored_with_transaction_failure]: "交易異常",
});

export const TransferCalcRoundText = Object.freeze({
  [TransferCalcRound.unchanged]: "不處理",
  [TransferCalcRound.roundUpToInt]: "無條件進位至整數",
  [TransferCalcRound.roundUpToDime]: "無條件進位至小數點第一位",
  [TransferCalcRound.roundUpToCent]: "無條件捨去至小數點第二位",
  [TransferCalcRound.roundOffToInt]: "四捨五入至整數",
  [TransferCalcRound.roundOffToDime]: "四捨五入至小數點第一位",
  [TransferCalcRound.roundOffToCent]: "四捨五入至小數點第二位",
  [TransferCalcRound.roundDownToInt]: "無條件捨去至整數",
  [TransferCalcRound.roundDownToDime]: "無條件捨去至小數點第一位",
  [TransferCalcRound.roundDownToCent]: "無條件捨去至小數點第二位",
});

export const TransferCalcRoundOptions = Object.freeze([
  { label: "不處理", value: TransferCalcRound.unchanged },
  { label: "無條件進位至整數", value: TransferCalcRound.roundUpToInt },
  { label: "無條件進位至小數點第一位", value: TransferCalcRound.roundUpToDime },
  { label: "無條件進位至小數點第二位", value: TransferCalcRound.roundUpToCent },
  { label: "四捨五入至整數", value: TransferCalcRound.roundOffToInt },
  { label: "四捨五入至小數點第一位", value: TransferCalcRound.roundOffToDime },
  { label: "四捨五入至小數點第二位", value: TransferCalcRound.roundOffToCent },
  { label: "無條件捨去至整數", value: TransferCalcRound.roundDownToInt },
  {
    label: "無條件捨去至小數點第一位",
    value: TransferCalcRound.roundDownToDime,
  },
  {
    label: "無條件捨去至小數點第二位",
    value: TransferCalcRound.roundDownToCent,
  },
]);
